<template lang="html">
<div class="pgInner adsMessage" :style="'height:' + pageH + 'px;'">

      <div class="tabNavs" ref="tabNavs">
           <span>申报匹配</span>
           <div class="btns">
                <el-button  @click="goFrash" size="mini">刷新</el-button>
                <!-- <el-button type="primary"  @click="goEdit('new')" size="mini">新建</el-button> -->
           </div>
      </div>

      <div class="seekLine">
          <div class="seekGp">
              <el-input placeholder="请输入关键字" v-model="listParams.keyword" @input="reInxList">
                    <el-button @click="reInxList" slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>

      </div>

      <div class="pgbody">

          <el-table
             :data="listData"
             header-row-class-name="tableHead"
             @selection-change="tabSelect"
             v-loading="loading"
             style="width: 100%">

             <el-table-column
               prop="policyTypeIdName"
               label="产业方向">
             </el-table-column>

             <el-table-column
               prop="subjectTypeName"
               align="center"
               width="120"
               label="企业类型">
             </el-table-column>

             <el-table-column
               align="center"
               width="210"
               label="近一年">

               <template slot-scope="scope">
                    <div v-html="transCode(scope.row)"></div>
               </template>

             </el-table-column>

             <el-table-column
               prop="numberOfParticipantsName"
               align="center"
               width="120"
               label="人员规模">
             </el-table-column>

             <el-table-column
               prop="intellectualPropertyName"
               align="center"
               width="120"
               label="知识产权">
             </el-table-column>

             <el-table-column
               prop="patentName"
               align="center"
               width="120"
               label="发明专利">
             </el-table-column>

             <el-table-column
               prop="userName"
               align="center"
               width="120"
               label="发布者">
             </el-table-column>

             <el-table-column
               prop="enterpriseName"
               align="center"
               label="所属企业">
             </el-table-column>

             <el-table-column
               prop="updatedAt"
               width="180"
               align="center"
               label="发布时间">
             </el-table-column>

             <el-table-column
               width="120"
               align="center"
               label="操作">
               <template slot-scope="scope">
  <div class="ibtn">
    <span @click="goEdit(scope.row)">查看</span>
    <div class="dvLine"></div>
  </div>
</template>
             </el-table-column>


          </el-table>

          <div class="table-footer">

              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="handleCurrentChange"
                :current-page="listParams.no"
                :page-count="allPages"
                layout="total, prev, pager, next, jumper">
              </el-pagination>

          </div>

      </div>

</div>
</template>

<script>
import { matchList } from "@/api/enterprise/index";
import { getEnterpriseList } from "@/api/attes/attestation";
import { enterpriseRemove } from "@/api/enterprise/index";
export default {
  computed: {
    lineStr: function () {
      var str = "left:" + this.navX + "px;";
      return str;
    }
  },
  filters: {

  },
  data() {
    return {
      pageH: '',

      options: [],
      listData: [],
      selectArr: [],

      loading: false,

      listParams: {
        keyword: '',
        statusList: '',
        no: 1,
        size: 20
      },

      allPages: 0,
      allEls: 0,

      options: [
        { key: 1, name: '未认证' },
        { key: 2, name: '已认证' },
        { key: 4, name: '审核失败' }
      ],

      typeId: ''  // 活动通告类型 id
    }
  },
  methods: {
    transCode: function (e, type) {
      var text = '';
      if (e.operatingIncome) {
        text = text + '<div>营业收入：' + e.operatingIncome + '万元</div>';
      };
      if (e.corporateProfits) {
        text = text + '<div>企业利润：' + e.corporateProfits + '万元</div>';
      };
      if (e.technologyFunding) {
        text = text + '<div>研发经费：' + e.technologyFunding + '万元</div>';
      };

      return text;
    },
    getList: function () {
      s
      this.loading = true;
      matchList(this.listParams).then(res => {
        this.listData = res.declareMyMatchConditionsList;
        this.loading = false;
        this.allPages = res.totalPages;
        this.allEls = res.totalElements;
      })
    },
    pageFix: function () {
      this.pageH = document.documentElement.clientHeight - 50;
    },

    selectChange: function (e) {
      this.listParams[e.paramsKey] = e.id;
      this.reInxList();
    },

    goRemove: function (e) {     // 批量删除
      var vues = this;
      if (e) {
        this.tabSelect([e]);
      }
      if (this.selectArr.length > 0) {
        this.$confirm('确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeEntUser({ ids: [e.id] }).then(res => {
            vues.reInxList();
          })
        })
      } else {
        this.$message.error('请选择删除项！');
      }
    },

    changeState: function (status, e) {
      var vues = this;
      if (e) {
        this.tabSelect([e]);
      }
      if (this.selectArr.length > 0) {
        statusSet({ ids: this.selectArr, status: status }).then(res => {
          vues.reInxList();
          vues.selectArr = [];
        })
      } else {
        this.$message.error('请选择操作项！');
      }
    },

    goEdit: function (e) {   // 编辑
      this.$router.push({
        path: 'match_view',
        query: {
          id: e.userId
        }
      });
    },

    tabSelect: function (e, type) {
      var arrs = [];
      if (type == 1) {
        arrs = [e.id];
        this.selectArr = arrs;
        this.goRemove();
      } else {
        e.forEach(item => {
          arrs.push(item.id);
        })
        this.selectArr = arrs;
      }
    },

    handleCurrentChange: function (e) {
      this.listParams.no = e;
      this.getList();
    },
    reInxList: function () {
      this.listParams.no = 1;
      this.getList();
    },
    goFrash: function () {
      this.$emit('go-frash');
    },
    prevSet: function () {

      // 底部定位
      this.pageFix();
      this.typeIdSet();


    },
  },
  created: function () {

    this.pageFix();
    this.getList();

  }
}
</script>

<style lang="scss" scoped>
.pgInner {
  background: #f5f5f5;
}

.tabNavs {
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: white;
  position: relative;
  border-bottom: 1px solid #efefef;
  .btns {
    float: right;
    height: 60px;
    padding-right: 20px;
  }
}

.seekLine {
  padding: 20px;
  background: white;
  .seekGp {
    width: 420px;
    display: inline-block;
  }

  .inpGp {
    width: 150px;
    display: inline-block;
    margin-left: 12px;
  }
}

.exLine {
  padding: 9px 0px;
  position: relative;

  .iName {
    width: 80px;
    float: left;
  }

  .iContent {
    margin-left: 80px;
    color: #999999;
  }
}

.pocLine {
  margin-top: 9px;
}

.pgbody {
  margin: 20px;
  .ibtn {
    display: inline-block;
    font-size: 14px;
    margin-right: 3px;
    span {
      cursor: pointer;
      color: #409eff;
    }
    .dvLine {
      display: inline-block;
      height: 14px;
      width: 2px;
      vertical-align: middle;
      margin-top: -2px;
      margin-left: 3px;
      background: #eaeaea;
    }
  }

  .ibtn:last-child .dvLine {
    display: none;
  }

  .table-footer {
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns {
      float: left;
      line-height: 50px;
    }

    .paging {
      display: inline-block;
      margin-top: 9px;
    }
  }
}
</style>

<style lang="scss">
.adsMessage .tableHead th {
  background: #efefef;
  font-weight: normal;
  color: #666666;
}

.adsMessage .seekLine {
  .el-input__inner {
    border-radius: 0px !important;
  }

  .el-input-group__append {
    border-radius: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// matchList.vue?4caae9b6